import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { alarmSeverity, deviceTypeToIcon, getTrimmedString } from '../utils';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';

import './DeviceAlarmCard.css';

const deviceStatuses = {
  OFFLINE: 0,
  COMMISSIONED: 1,
  LOCKED: 2
};

const DeviceAlarmCard = (props) => {
  const getStatuses = () => {
    let statuses = [];

    statuses.push(props.connectionState === 'Connected');
    statuses.push(props.isCommissioned);

    const lockedStates = ['locked', 'lock'];
    statuses.push(lockedStates.includes(props.adminState));

    return (
      <div className="DeviceAlarmCard_TopContent_Statuses">
        {statuses.map((status, index) => getSingleStatus(status, index))}
      </div>
    );
  };

  const getSingleStatus = (statusValue, index) => {
    let currIcon = null;
    let tooltip = '';

    switch (index) {
      case deviceStatuses.OFFLINE:
        currIcon = statusValue ? IconLoader.icon_offline : IconLoader.icon_offline_off;
        tooltip = props.connectionState;
        break;
      case deviceStatuses.COMMISSIONED:
        currIcon = statusValue ? IconLoader.icon_not_commissioned_off : IconLoader.icon_not_commissioned;
        tooltip = statusValue ? 'Commissioned' : 'Not commissioned';
        break;
      case deviceStatuses.LOCKED:
        currIcon = statusValue ? IconLoader.icon_locked_device : IconLoader.icon_locked_device_off;
        tooltip = statusValue
          ? 'Locked'
          : props.adminState.substring(0, 1).toUpperCase() + props.adminState.substring(1).toLowerCase();
        break;
      default:
        break;
    }

    return (
      <div className="DeviceAlarmCard_TopContent_SingleStatus" key={index}>
        <SvgAF img={currIcon} scaleImg={true} tooltip={tooltip} />
      </div>
    );
  };

  const getAlarms = () => {
    return (
      <div
        className="DeviceAlarmCard_BottomContent_Alarms"
        data-tip="See alarm details"
        onClick={() => props.onSelect(props.device, props.deviceId, props.displayName)}
      >
        {props.alarmCounts.map((alarmNum, index) => getSingleAlarmIconAndText(alarmNum, index))}
      </div>
    );
  };

  const getSingleAlarmIconAndText = (alarmNum, index) => {
    let currIcon = null;
    let dimension = 24;

    switch (index) {
      case alarmSeverity.CRITICAL:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_critical_none : IconLoader.icon_alarm_critical_num;
        dimension = 34;
        break;
      case alarmSeverity.MAJOR:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_major_minor_none : IconLoader.icon_alarm_major_num;
        dimension = 30;
        break;
      case alarmSeverity.MINOR:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_major_minor_none : IconLoader.icon_alarm_minor_num;
        dimension = 30;
        break;
      case alarmSeverity.WARNING:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_warning_info_none : IconLoader.icon_alarm_warning_num;
        break;
      case alarmSeverity.INFO:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_warning_info_none : IconLoader.icon_alarm_info_num;
        break;
      case alarmSeverity.UNKNOWN:
        currIcon = alarmNum === 0 ? IconLoader.icon_alarm_unknown_none : IconLoader.icon_alarm_unknown_num;
        break;
      default:
        break;
    }
    const majorIconClassName = 'DeviceAlarmCard_BottomContent_SeverityIcon';
    const minorIconClassName = majorIconClassName + '_' + dimension;

    return (
      <div className="DeviceAlarmCard_BottomContent_Single_Alarm" key={index}>
        <div className={majorIconClassName + ' ' + minorIconClassName}>
          <SvgAF img={currIcon} scaleImg={true} />
        </div>
        {alarmNum !== 0 && (
          <div
            className={classnames(
              { DeviceAlarmCard_BottomContent_SeverityNum: true },
              { DeviceAlarmCard_BottomContent_SeverityNum_Unknown: index === alarmSeverity.UNKNOWN }
            )}
          >
            {alarmNum}
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={classnames(
        { DeviceAlarmCardContainer: !props.isEmpty && !props.isHighlighted },
        { DeviceAlarmCardContainer_Selected: !props.isEmpty && props.isHighlighted },
        { DeviceAlarmCardContainer_Empty: props.isEmpty }
      )}
    >
      {props.isEmpty && <div className="DeviceAlarmCard_Empty"></div>}
      {!props.isEmpty && (
        <div className="DeviceAlarmCard_TopContent">
          <div className="DeviceAlarmCard_TopContent_DeviceIcon">
            <img src={deviceTypeToIcon[props.deviceType] || IconLoader.icon_donor} alt="" />
          </div>
          <Link
            className="DeviceAlarmCard_TopContent_DeviceID"
            to={'/console/devices/detail?' + props.deviceId}
            data-tip="See device details"
          >
            {getTrimmedString(props.displayName, 21)}
          </Link>
          {getStatuses()}
        </div>
      )}
      {!props.isEmpty && (
        <div className="DeviceAlarmCard_BottomContent">
          {getAlarms()}
          <div className="DeviceAlarmCard_BottomContent_Highlight" onClick={() => props.onHighlight(props.deviceId)}>
            {
              <SvgAF
                img={props.isHighlighted ? IconLoader.icon_highlight_hover : IconLoader.icon_highlight}
                hover={props.isHighlighted ? IconLoader.icon_highlight : IconLoader.icon_highlight_hover}
                tooltip={props.isHighlighted ? '' : 'Highlight the item'}
                scaleImg={true}
              />
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(DeviceAlarmCard);
